module.exports = __webpack_public_path__ + "img/sit.d0cc7d86.png";